//ULP
export const ULP_DYNAMIC_LEVEL = [
  { value: "UC", label: "UC" },
  { value: "Warehouse", label: "Warehouse" },
];

export const IS_AGREEMENT_CHECK = "isAgreementCheck";
export const DISCOUNT_PER_UNIT = "discountPerUnit";
export const PROMO_DESCRIPTION = "promoDescription";
export const PROMO_STATUS = "promoStatus";
export const PROMO_SLAB_LEVEL = 2;
export const BASKET_PROMO_SLAB_LEVEL = 1;
export const PROMO_TYPE = {
  VOLUMETRIC: "VOLUMETRIC",
  BASKET: "BASKET",
  DYNAMIC: "DYNAMIC",
  ULP: "USER_LEVEL",
};
export const PROMO_VALUE_TYPE = {
  INTEGER: "INTEGER",
  FLOAT: "FLOAT",
};

//channelOptions
export const CHANNEL_OPTIONS = {
  // volumetric
  0: [
    {
      id: "CUSTOMER_APP",
      key: "CUSTOMER_APP",
      title: "CUSTOMER_APP",
      name: "CUSTOMER_APP",
    },
    {
      id: "AGENT_APP",
      key: "AGENT_APP",
      title: "AGENT_APP",
      name: "AGENT_APP",
    },
  ],
  // basket
  1: [
    {
      id: "CUSTOMER_APP",
      key: "CUSTOMER_APP",
      title: "CUSTOMER_APP",
      name: "CUSTOMER_APP",
    },
    {
      id: "TELESALES",
      key: "TELESALES",
      title: "TELESALES",
      name: "TELESALES",
    },
  ],
  // dynamic
  2: [
    {
      id: "CUSTOMER_APP",
      key: "CUSTOMER_APP",
      title: "CUSTOMER_APP",
      name: "CUSTOMER_APP",
    },
  ],
  // user level
  3: [
    {
      id: "CUSTOMER_APP",
      key: "CUSTOMER_APP",
      title: "CUSTOMER_APP",
      name: "CUSTOMER_APP",
    },
  ],
};

//promoOptions
export const PROMO_OPTIONS = [
  {
    id: "1",
    key: "0",
    title: "Volumetric Promo",
  },
  {
    id: "2",
    key: "1",
    title: "Basket Promo",
  },
  {
    id: "3",
    key: "2",
    title: "Dynamic Promo",
  },
  {
    id: "4",
    key: "3",
    title: "User Level Promo",
  },
];

//promoBasketDiscountOptions
export const PROMO_BASKET_DISCOUNT_OPTIONS = [
  {
    id: "1",
    key: "0",
    title: "Rs",
  },
  {
    id: "2",
    key: "1",
    title: "%",
  },
];

export const PROMO_TYPE_CONST = {
  VOLUMETRIC: "0",
  BASKET: "1",
  DYNAMIC: "2",
  ULP: "3",
};

export const UC = "UC";
export const WAREHOUSE = "Warehouse";
export const NEW_PROMO = "New promo";
export const NEW_BULK_PROMO = "Create Bulk Promo";
export const UPDATE_A_PROMO = "Update a promo";
export const ADD_A_PROMO = "Add a promo";
export const CHANNEL = "channel";
export const TYPE_PROMO = "promoType";
export const BASKET_CATEGORIES = "basketCategories";
export const DYNAMIC_PROMO_CRITERIA_TYPE = "dynamicPromoCriteriaType";
export const CREATE_BULK_PROMO = "Create Promo";
